const invalidPath = (path: string) => {
  return !path;
};

const invalidSlugs = (slugs: object) => {
  return !slugs || typeof slugs !== "object" || Object.keys(slugs).length !== 2;
};

const containesURLParameters = (path: string) => {
  return path.includes("?");
};

const urlSlugController = (slugs: object, path: string) => {
  if (invalidPath(path)) {
    console.log("urlSlugController invalid path");
    return "/";
  }
  if (invalidSlugs(slugs)) {
    console.log("urlSlugController invalid slugs");
    return path;
  }
  let urlSlug = "/";
  let urlParameters = "";
  if (containesURLParameters(path)) {
    urlParameters = "?" + path.split("?")[1];
  }
  for (const slug in slugs) {
    if (slugs[slug]) {
      urlSlug = urlSlug + slugs[slug] + "/";
    }
  }

  if (path.startsWith("/mobile/")) {
    return "/mobile" + urlSlug + urlParameters;
  }

  return urlSlug + urlParameters;
};

export default urlSlugController;
